/**
 * Rolling strafe-sync meter — the classic surf skill metric: of recent
 * airborne ticks where the view was turning, the fraction in which horizontal
 * speed actually grew. 100% = every turn converted into speed.
 */
export class StrafeSync {
  private readonly turning: boolean[] = [];
  private readonly gained: boolean[] = [];
  private index = 0;
  private filled = 0;

  constructor(private readonly windowSize = 100) {}

  record(airborne: boolean, yawDelta: number, speedDelta: number): void {
    if (!airborne) {
      return; // only airborne ticks count
    }
    const isTurning = Math.abs(yawDelta) > 1e-4;
    if (!isTurning) {
      return;
    }
    this.turning[this.index] = true;
    this.gained[this.index] = speedDelta > 0;
    this.index = (this.index + 1) % this.windowSize;
    this.filled = Math.min(this.filled + 1, this.windowSize);
  }

  /** 0-100, or null when there's no recent turning data to judge. */
  percent(): number | null {
    if (this.filled < 10) {
      return null;
    }
    let gained = 0;
    for (let i = 0; i < this.filled; i++) {
      if (this.gained[i]) {
        gained++;
      }
    }
    return Math.round((100 * gained) / this.filled);
  }

  reset(): void {
    this.turning.length = 0;
    this.gained.length = 0;
    this.index = 0;
    this.filled = 0;
  }
}
